/** @format */

const template = `
<div class="search-filter">
  <ng-form name="filterSelectorForm" novalidate ng-model-options="{ updateOn: 'default' }">
    <div class="row" ng-if="ctrl.filterSearch">
      <div class="col-12">
        <input
          class="form-control search-within-filter"
          type="text"
          placeholder="Hae"
          ng-if="ctrl.filterSearch"
          ng-model="ctrl.searchWithinFilter" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <ul class="filter-selectbox selectbox-single">
          <li
            ng-repeat="filterValue in ctrl.filterValues | filter: ctrl.searchWithinFilter"
            tabindex="{{$index + 1}}"
            data-filter-id="{{filterValue}}"
            ng-focus="ctrl.setValue(filterValue, filterSelectorForm)">
            {{::ctrl.getFilterName(filterValue)}}
          </li>
        </ul>
      </div>
    </div>
    <div ng-if="ctrl.helpText" class="row help-block">
      <div class="col-12">
        <p>{{ctrl.helpText}}</p>
      </div>
    </div>
    <div class="row filter-preview-row">
      <div class="col-9">
        <div class="filter-preview-holder">
          <span class="filter-preview-title"> {{ctrl.filterName}} </span>
          <span class="filter-preview-content">
            <span ng-repeat="filterValue in ctrl.filterValues | filter: {checked: true}" ng-class="{'item-separator': !$first}"
              >{{::ctrl.getFilterName(filterValue)}}
            </span>
          </span>
        </div>
      </div>
      <div class="col-3">
        <button
          type="submit"
          class="btn btn-lg btn-primary filter-submit"
          ng-click="ctrl.submitFilter()"
          ng-disabled="filterSelectorForm.$pristine"
          translate="SEARCH.FILTER_SELECTOR.OK">
        </button>
      </div>
    </div>
  </ng-form>
</div>
`;
export default template;
